import { InjectionToken } from "@angular/core";

export const AUTH_PROVIDERS: InjectionToken<string> = new InjectionToken<
  string
>("AUTH_PROVIDERS");
